import { useState, useEffect } from 'react';

const ResponsiveLink = ({ 
  href, 
  product = null, 
  children, 
  onClick = () => {}, 
  className = "", 
  targetWindowName = 'ExternalWindow', 
  ...props 
}) => {
  const [isReady, setIsReady] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateTarget = () => {
      const mobileCheck = window.matchMedia('(max-width: 768px)').matches;
      setIsMobile(mobileCheck);
      setIsReady(true);
    };

    updateTarget();
    window.addEventListener('resize', updateTarget);
    return () => window.removeEventListener('resize', updateTarget);
  }, []);

  const handleClick = async (e) => {
    // Only prevent default if we're handling the navigation
    if (!isMobile || product) {
      e.preventDefault();
    }

    // Track click if product exists
    if (product) {
      try {
        await fetch(`/api/products/${product._id}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        });
      } catch (error) {
        console.error('Error tracking click:', error);
      }
    }

    // Handle navigation
    if (!isMobile) {
      // Desktop: reuse named window
      window.open(href, targetWindowName);
    } else {
      // Mobile: allow default behavior (new tab) unless tracking was needed
      if (!product) return;
      window.open(href, '_blank');
    }

    if (typeof onClick === 'function') onClick(e);
  };

  if (!isReady) return null;

  return (
    <a
      className={className}
      href={href}
      onClick={handleClick}
      target={isMobile ? '_blank' : targetWindowName}
      rel="noopener noreferrer"
      {...props}
    >
      {children}
    </a>
  );
};

export default ResponsiveLink;